import { Entity } from 'dexie';
import type { AppDB } from '../db';

class LandmarkCategory extends Entity<AppDB> {
  public uid!: number;
  public label!: string;
  public symbol!: number;
  public timestamp!: number;
  public uid_parent!: number;
  public categories!: number[];
  public landmarks!: number[];
  public popup?: number;
}

export default LandmarkCategory;
